module.exports = "/images/Arrow-Small-down.png?b66cbde81767f1809fc561c8f32a5b4e";


//////////////////
// WEBPACK FOOTER
// ./resources/images/project-img/Arrow-Small-down.png
// module id = zQOA
// module chunks = 1